import { Outlet } from 'react-router-dom';
import { IconNavDocumentText } from '../../components/icons';
import { AppShellGrid, type NavEntry } from '../../components/Sidebar';
import { useDict } from '../../i18n/dictionary';
import { useAppCrumb } from '../../layouts/AppLayout';
import { recipesDict } from './i18n';

/**
 * One entry: the list. A prefix match keeps it lit on a recipe, its form and
 * the new-recipe page, which are all reached from the list.
 */
export function RecipesLayout() {
  const t = useDict(recipesDict);
  useAppCrumb('recipes', t.appName, '/recipes');
  const nav: NavEntry[] = [
    {
      key: 'recipes',
      href: '/recipes',
      label: t.recipes,
      icon: IconNavDocumentText,
    },
  ];
  return (
    <AppShellGrid items={nav}>
      <Outlet />
    </AppShellGrid>
  );
}
